<template>
    <p :class="[pClass, { invalid: isInvalid }]">
      <label v-if="!omitLabel && required" :for="id"><slot/> *<span v-if="helpText"> ({{ helpText }})</span></label>
      <label v-if="!omitLabel && !required" :for="id"><slot/><span v-if="helpText"> ({{ helpText }})</span></label>
      <select2
          :id="id"
          :name="id"
          :disabled="disabled"
          v-model="selected"
          :options="selectOptions"
          :settings="mergedSettings"
          @change="onChange"
          @blur="setTouched(true)"
          @open="onOpen"
      ></select2>
        <span class="invalid_help" v-if="isInvalid && invalidText">{{ invalidText }}</span>
    </p>
</template>

<script>
import Select2 from 'v-select2-component'

	export default {
		name: "SelectBox",
    components: {Select2},
		data() {
			return {
				touched: false,
        forcedInvalid: false,
        invalidText: null,
			}
		},
		props: {
			id: String,
			value: [String, Number, Boolean],
			label: String,
			options: [Array, Object],
			undefinedValue: String,
			undefinedText: String,
			required: Boolean,
			disabled: Boolean,
			omitLabel: Boolean,
			pClass: {
				type: String,
				default: 'field',
			},
      settings:{
        allowClear:true,

      },
      helpText: {
        type: String,
        default: ''
      },
		},
    mounted() {
      $('#'+this.id).parent().contents().unwrap();
    },
    computed: {
			selected: {
				get() {
          if(this.value === null){
            return -1;
          }
					return this.value;
				},
				set() {
					// declaring setter, but assigning value with onChange method
				}
			},
			isInvalid: function () {
				return (this.touched && this.required && this.valueIsEmpty) || this.isForcedInvalid
			},
      valueIsEmpty() {
				return this.value === null || this.value === undefined || this.value === 0 || this.value === '0'
            },
			isForcedInvalid() {
				return this.forcedInvalid
			},
      selectOptions(){
        let selectOptions = this.options;
        if(this.undefinedText){
          selectOptions.unshift({'id':this.undefinedValue === null ? -1: this.undefinedValue, 'text': this.undefinedText})
          selectOptions = [...selectOptions];
        }
        selectOptions.forEach((item) =>{
          item.id = item.id === null? -1 : item.id;
          return item;
        });
        return selectOptions;
      },
      mergedSettings() {
        return {
          ...this.settings,
        }
      }
		},
		methods: {
			onChange(value) {
				if (value === '' || value === '-1') {
					value = null
				}
				this.$emit('input', value)
				this.setTouched(true)
			},
			setTouched(value) {
				this.touched = value
			},
			setForcedInvalid(value = false, invalidText = null) {
				this.forcedInvalid = value
				this.invalidText = value === false ? null : invalidText
			},
      onOpen(){
        $('input.select2-search__field').focus();
      },
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/common/SelectBox.vue